import React from 'react';

export default function Disclaimer() {
  return (
    <div style={{ marginTop: 30 }}>
      <p>
        <strong>
          * FitnessRepairParts.com (Fitness Plus Equipment Services, Inc.) is not affiliated with, nor does it endorse or recommend any of the above listed companies. They have listed themselves as a service center in the shown areas, and we cannot verify the quality of service provided by any of the companies.
        </strong>
      </p>
      <p>
        If you would like to include your business on this list of servicers, listing is free. <a href="/pdf/acct_referral.pdf">Simply follow the instructions provided in the document linked here</a>.
      </p>
    </div>
  );
}